import { useNavigate } from "react-router-dom";
import { FaArrowRight } from "react-icons/fa";
import "./GettingStarted.css";

const GettingStarted = () => {
    const navigate = useNavigate();

    const topics = [
        {
            category: "General",
            questions: [
                {
                    text: "How Does the Incorporation Process Work?",
                    link: "/how-the-usa-incorporation-process-word"
                },
                {
                    text: "Can a Non-US Resident or Non-US Citizen Incorporate in the US?",
                    link: "/can-a-non-us-resident-or-non-us-citizen-incorporate-in-the-us"
                },
                {
                    text: "6 reasons why your startup should be incorporated in the US?",
                    link: "/why-should-your-startup-incorporate-in-the-usa"
                },
                {
                    text: "EIN (Employer Identification Number): What It Is?",
                    link: "/ein-employer-identification-number-what-it-is"
                },
                {
                    text: "What Are the Ongoing Compliance Requirements After US Incorporation?",
                    link: "/what-are-the-ongoing-compliance-requirements-after-us-incorporation?"
                },
                {
                    text: "Opening a US Business Bank Account as a Non-Resident: What Are Your Options?",
                    link: "/opening-a-us-business-bank-account-as-a-non-resident-what-are-your-options?"
                }
            ]
        },
    ];

    return (
        <div className="gs-container">
            <header className="gs-header">
                <div className="gs-container-1200">
                    {/* <div className="gs-header-content">
                        <button 
                            className="gs-back-btn"
                            onClick={() => navigate(-1)}
                        >
                            <FaArrowLeft /> Back
                        </button>
                        <div className="gs-logo">
                            <a href="/">BooksComply</a>
                        </div>
                        <div className="gs-top-bar">
                            <a href="/submitrequest" className="gs-submit-btn">
                                <FaQuestionCircle className="btn-icon" /> Submit a request
                            </a>
                        </div>
                    </div> */}
                </div>
            </header>
            
            <main className="gs-main-content">
                <div className="gs-container-1200">
                    <nav className="gs-breadcrumb">
                        <ol>
                            <li><a href="/help">Help Center</a></li>
                            <li>Getting Started</li>
                        </ol>
                    </nav>

                    <div className="gs-header-content">
                        <div>
                            <h1>Getting Started</h1>
                            <p className="gs-subtitle">Everything you need to start a company with BooksComply</p>
                        </div>
                        {/* <div className="gs-search-container">
                            <FaSearch className="search-icon" />
                            <input 
                                type="text" 
                                placeholder="Search articles..." 
                                className="gs-search-input"
                            />
                        </div> */}
                    </div>

                    <div className="gs-topics-container">
                        {topics.map((topic, index) => (
                            <div key={index} className="gs-topic-section">
                                <h2 className="gs-topic-title">{topic.category}</h2>
                                <div className="gs-questions-list">
                                    {topic.questions.map((question, qIndex) => (
                                        <div 
                                            key={qIndex} 
                                            className="gs-question-item"
                                            onClick={() => navigate(question.link)}
                                        >
                                            <div className="gs-question-content">
                                                <h3>{question.text}</h3>
                                                <FaArrowRight className="arrow-icon" />
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        ))}
                    </div>

                    <div className="gs-contact-section">
                        <h2>Still need help?</h2>
                        <p>Can't find what you're looking for? Our support team is here to help.</p>
                        <a href="/submitRequest" className="gs-contact-btn">Contact Support</a>
                    </div>
                </div>
            </main>
        </div>
    );
};

export default GettingStarted;